import { Component, OnInit, OnDestroy } from "@angular/core";
import { ApiCallingService } from "../../services/api-calling.service";
import { ConfigApi } from "../../config-api";
import { Globals } from "../../common/global";
import { Subject } from "rxjs";
import { debounceTime, distinctUntilChanged, takeUntil } from "rxjs/operators";

@Component({
  selector: "app-my-asset-ride-history",
  templateUrl: "./my-asset-ride-history.component.html",
  styleUrls: ["./my-asset-ride-history.component.css"],
})
export class MyAssetRideHistoryComponent implements OnInit, OnDestroy {
  modeltitle: any;
  page = 1;
  pageSize = 10;
  data = [];
  totalcount = 0;
  detail: any;
  searchTerm = "";

  private searchSubject = new Subject<string>();
  private destroy$ = new Subject<void>();

  constructor(
    private apiCallingService: ApiCallingService,
    public Globals: Globals
  ) {}

  ngOnInit(): void {
    this.data = [];

    this.searchSubject
      .pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.page = 1;
        this.getList();
      });

    this.getList();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.searchSubject.complete();
  }

  onSearchChange(event: any): void {
    if (this.searchTerm.length >= 3 || this.searchTerm.length === 0) {
      this.searchSubject.next(this.searchTerm);
    }
  }

  getList() {
    if (
      this.searchTerm &&
      this.searchTerm.length > 0 &&
      this.searchTerm.length < 3
    ) {
      return;
    }
    const user_id = this.Globals.user._id;
    var body = {
      userId: user_id,
      page: this.page - 1,
      limit: this.pageSize,
      search: this.searchTerm,
    };
    this.apiCallingService
      .callAPI(body, "POST", ConfigApi.URLS.MY_ASSET_RIDE_HISTORY)
      .subscribe((res) => {
        this.data = res.data;
        this.totalcount = res.total;
      });
  }

  loadPage(page: number) {
    this.page = page;
    this.getList();
  }
}
